import { ApiService } from './api.service';
import { Activity } from '@/models/activity/activity';
import { ActivityItemCategory } from '@/models/activity/activity';
import { CreateActivityParam, UpdateActivityParam } from '@/models/activity/activity';
import { Empty } from '@/models/core/empty';

class ActivityService extends ApiService {
  constructor() {
    super();
  }

  // 学校のもの + JTB作成のもの
  getActivities(): Promise<Activity[]> {
    return this.getList(Activity, 'jgrow/activity', {});
  }

  // 学校のもの + JTB作成のもの
  getCategoriesWithItem(): Promise<ActivityItemCategory[]> {
    return this.getList(ActivityItemCategory, 'jgrow/category', {});
  }

  // 新規作成
  createActivity(param: CreateActivityParam): Promise<Empty> {
    return this.post(Empty, 'jgrow/activity', param);
  }

  // 更新
  updateActivity(param: UpdateActivityParam): Promise<Empty> {
    return this.put(Empty, 'jgrow/activity', param);
  }

  // 削除
  deleteActivity(id: number): Promise<Empty> {
    return this.delete(`jgrow/activity/${id}`, {});
  }
}

export const activityService = new ActivityService();
